import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    autoPlay: { type: Boolean, default: false },
    particleCount: { type: Number, default: 100 },
    duration: { type: Number, default: 3000 }
  }

  connect() {
    if (this.autoPlayValue) {
      this.play()
    }
  }

  // Check if user prefers reduced motion for accessibility
  prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }

  play() {
    // Respect user's motion preferences for accessibility
    if (this.prefersReducedMotion()) {
      // Skip confetti animation but still show emoji pulse briefly
      this.animateEmojiReduced()
      return
    }
    this.createConfetti()
    this.animateEmoji()
  }

  // Minimal animation for reduced motion preference
  animateEmojiReduced() {
    const emoji = this.element.querySelector("[data-confetti-target='emoji']")
    if (emoji) {
      // Just add a subtle scale effect instead of bounce
      emoji.style.transform = "scale(1.1)"
      setTimeout(() => {
        emoji.style.transform = ""
      }, 300)
    }
  }

  createConfetti() {
    const container = document.createElement("div")
    container.className = "confetti-container"
    document.body.appendChild(container)

    const colors = [
      "#ffd333",
      "#84cc16",
      "#22c55e",
      "#f5c300",
      "#a3e635",
      "#fde047",
      "#bef264",
    ]

    for (let i = 0; i < this.particleCountValue; i++) {
      const confetti = document.createElement("div")
      confetti.className = "confetti-piece"
      
      const color = colors[Math.floor(Math.random() * colors.length)]
      const size = Math.random() * 8 + 6
      const left = Math.random() * 100
      const delay = Math.random() * 1
      const rotation = Math.random() * 360
      
      const shapes = ["50%", "0", "50% 0 50% 50%"]
      const shape = shapes[Math.floor(Math.random() * shapes.length)]
      
      confetti.style.cssText = `
        left: ${left}%;
        width: ${size}px;
        height: ${size}px;
        background-color: ${color};
        border-radius: ${shape};
        animation-delay: ${delay}s;
        animation-duration: ${2 + Math.random() * 2}s;
        transform: rotate(${rotation}deg);
      `
      
      container.appendChild(confetti)
    }

    setTimeout(() => {
      container.remove()
    }, this.durationValue + 1000)
  }

  animateEmoji() {
    const emoji = this.element.querySelector("[data-confetti-target='emoji']")
    if (emoji) {
      emoji.classList.add("celebration-bounce")
      setTimeout(() => {
        emoji.classList.remove("celebration-bounce")
      }, 1000)
    }

    const celebrationElement = this.element.querySelector(".celebration-pulse")
    if (!celebrationElement) {
      this.element.classList.add("celebration-pulse")
      setTimeout(() => {
        this.element.classList.remove("celebration-pulse")
      }, 1500)
    }
  }

  trigger() {
    this.play()
  }
}
